<template>
  <div id="app">
    <headers></headers>
    <div class="teaching-list">
      <div class="w_1400">
        <!-- <el-button type="text" @click="dialogFormVisible = true">添加实践</el-button> -->
        <div class="previous-page" v-if="isdet">
          <a href="javascript:history.back(-1)"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
        </div>
        <div class="previous-page" v-else>
          <a href="#" style="float: left;" @click="isdet=true"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
        </div>

        <div class="teaching-list-left">
          <div class="teaching-list-user" v-if="userinfo">
            <p>
              <img :src="userinfo.avatar" alt="">
            </p>
            <h1>{{userinfo.nickname}}</h1>
          </div>

          <div class="teaching-list-nav">
            <h3>我的教学</h3>
            <ul>
              <!-- <li>
                <router-link to="/homecourse"><a href="javascript();">在教课程</a></router-link>
              </li> -->
              <li>
                <router-link to="/homework"><a href="javascript();">课程作业</a></router-link>
              </li>
              <li class="active">
                <router-link to="/practice"><a href="javascript();">实践作业</a></router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- 课程列表 -->
        <div class="teaching-list-right">
          <h3>作业详情</h3>

          <div class="teaching-list-table homework-table" v-if="isdet">
            <div class="teaching-list-form">
              <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select">

                <template slot="prepend">
                  <i class="el-icon-search"></i>
                </template>

                <el-button type="success" size="mini" slot="suffix" @click="searchs()">搜索</el-button>
              </el-input>
            </div>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column type="selection" width="50" />
              <el-table-column prop="id" label="编号" width="220">
              </el-table-column>
              <el-table-column prop="name" label="课程标题">
              </el-table-column>
              <el-table-column prop="time" label="发布时间">
                <template slot-scope="scope">{{ scope.row.time }}</template>
              </el-table-column>
              <!-- <el-table-column label="批阅状态(总作业量/待批阅)">

                <template slot-scope="scope" >
                  <span v-if="tableData[scope.$index].paper">
                  {{tableData[scope.$index].paper.totalcount}}/<font style="color: red;">
                    {{tableData[scope.$index].paper.unmarked_count}}
                  </font>
                  </span>
                  <span v-else>本课程没有作业</span>
                </template>
              </el-table-column> -->
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
                    学生作业
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;">
              <el-pagination layout="prev, pager, next" :total="total" :page-size="15" @next-click="nextpage"
                @prev-click="prevpage" @current-change="currentchange">
              </el-pagination>
            </div>
          </div>
          <!-- 作业列表 -->
          <div class="teaching-list-table homework-table" v-else>
            <div class="teaching-list-form">
              <el-input placeholder="请输入内容" v-model="keyword1" class="input-with-select">

                <template slot="prepend">
                  <i class="el-icon-search"></i>
                </template>

                <el-button type="success" size="mini" slot="suffix" @click="searchs()">搜索</el-button>
              </el-input>
            </div>
            <div v-if="correctStatus==true">
              <el-button  type="text"
                size="middle" @click="part()">
                批量批改
              </el-button>
            </div>
            <div v-if="correctStatus==true">
              <el-button  type="text"
                size="middle" @click="all()">
                一键批改
              </el-button>
            </div>
            <el-table :data="tableData2"
              class="table"
              ref="table"
              :row-class-name="row_class_name2"
              @selection-change="selection_change2"
              @row-click="row_click2">
              <el-table-column type="selection" width="50" />
              <el-table-column prop="nickname" label="学员昵称" width="220">
              </el-table-column>
              <el-table-column prop="sn" label="学号" width="220">
              </el-table-column>
              <el-table-column prop="time" label="提交时间" width="220">
              </el-table-column>
              <el-table-column label="作业状态">
                <template slot-scope="scope">
                  <font :style="scope.row.audit==1?'color:#80D676;':''">
                    {{scope.row.audit==1?'未批阅':'已批阅'}}
                  </font>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button v-if="tableData2[scope.$index].audit==2"
                    @click.native.prevent="correction(scope.$index, tableData)" type="text" size="small">
                    查看详情
                  </el-button>
                  <el-button v-else @click.native.prevent="correction(scope.$index, tableData)" type="text"
                    size="small">
                    立即批改
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;">
              <el-pagination layout="prev, pager, next" :total="total1" @next-click="nextpage" @prev-click="prevpage"
                :page-size="15" @current-change="currentchange">
              </el-pagination>
            </div>
          </div>
        </div>

        <el-dialog title="新建实践" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-form-item label="活动名称" :label-width="formLabelWidth">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="活动区域" :label-width="formLabelWidth">
              <el-select v-model="form.region" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
          </div>
        </el-dialog>

      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import {
    teacherpaper,
    practicepaperlist,
    practicelist,
    practicepartcorrect
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      footers
    },
    data() {
      return {
        tableData: [],
        search: '',
        userinfo: '',
        isdet: true,
        selection2: [],
        tableData2: [],
        total: 0,
        total1: 0,
        index1: 0,
        page: 1,
        page1: 1,
        keyword:'',
        keyword1:'',
        correctStatus:true,
        dialogFormVisible: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formLabelWidth: '120px',

      }
    },
    methods: {
      part(){
        //    1.弹出提示框
        this.$confirm("确定批量修改作业？","提示",{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:"info"
        }).then(()=> {
          this.partcorrect(this.selection2)
        }).finally(()=> {
          this.paperLists()
        }).catch(()=> {
          //    3.取消批改作业
          this.$message.info("取消批改作业");
        })
      },
      all(){
        //    1.弹出提示框
        this.$confirm("确定一键修改作业？","提示",{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:"info"
        }).then(()=> {
          this.partcorrect(this.tableData2)
        }).finally(()=> {
          this.paperLists()
        }).catch(()=> {
          //    3.取消批改作业
          this.$message.info("取消批改作业");
        })
      },
      //批量或者一键批改作业
      partcorrect(data){
        practicepartcorrect(data).then(res => {
              this.$message.info(res.msg);
          })
          setTimeout(() => {
            location.reload();
          }, 1500)
      },
      row_class_name2({ row, rowIndex }) {
          return this.selection2.find(v => v.value == row.value) ? 'selected' : '';
      },
      selection_change2(selection) {
          this.selection2 = selection;
      },
      row_click2(row, column, event) {
          this.$refs.table.toggleRowSelection(row)
      },
      // page被改变时触发的方法
      currentchange(event){
        if(this.isdet){
          this.page=event
          this.teacherpapers()
        }else{
          this.page1=event
          this.paperLists()
        }
      },
      // 点击了下一页时触发的方法
      nextpage() {
        if(this.isdet) {
          this.page++
          this.teacherpapers()
        } else {
          this.page1++
          this.paperLists()
        }
      },
      // 点击了上一页时触发的方法
      prevpage() {
        if(this.isdet) {
          this.page--
          this.teacherpapers()
        } else {
          this.page1--
          this.paperLists()
        }

      },

      searchs() {
        if(this.isdet){
          this.page = 1
          this.teacherpapers()
        } else{
          this.page1 = 1
          this.paperLists(this.index1)
        }
      },
      // 老师点击查看课程的方法
      deleteRow(index, rows) {
        this.isdet = false;
        this.index1 = this.tableData[index].id
        this.paperLists(this.tableData[index].id)
      },
      // 老师点击查看作业详情的方法
      correction(index, rows) {

        this.isdet = false;
        window.open(this.$router.resolve({
          name: 'operation',
          query: {
            paper_id: this.index1,
            id: this.tableData2[index].user_id,
            type:1
          }
        }).href,"_blank")
      },
      // 获取对应课程所有作业
      paperLists(id) {
        let self = this
        if(id){
          this.paper_id=id
        }else{

        }
        practicepaperlist({
          'practice_id': this.paper_id,
          'page': this.page1,
          'pagesize': 15,
          'keyword1':this.keyword1
        }).then(res => {
          this.tableData2 = res.data.data.data.map(item => {
            item.time = self.timestampToTime(item.answerCreatetime)
            return item;
          })
          this.total1 = res.data.data.total
          this.tableData2.all=1
          this.tableData2.paper_id=this.paper_id
          // this.correctStatus = res.data.correctStatus
        })
      },
      // 时间戳转日期格式
      timestampToTime(timestamp) {
        // 时间戳为10位需*1000，时间戳为13位不需乘1000
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + ".";
        var M =
          (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + ".";
        var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var s = date.getSeconds();
        return Y + M + D;
      },
      //获取课程列表
      practicelists() {
        let self = this
        practicelist({
          'page': this.page,
          'pageSize': 15,
          'keyword':this.keyword
        }).then(res => {
          this.tableData = res.data.data.map(item => {
            item.time = self.timestampToTime(item.createtime)
            return item;
          })
          this.total = res.data.total
        })
      }
    },
    // 初始化方法，加载完成时触发
    created() {
      this.practicelists();
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
    },
    mounted() {

    },
  }
</script>

<style>
  @import '../../assets/css/home.css';

  .el-button--small {
    width: 99.86px;
    height: 28.04px;
    background: #80D676;
    border-radius: 3.116px;
    color: #FDFDFD;
  }

  .el-button--middle {
    float:left;
    margin: 0px 15px;
    width: 99.86px;
    height: 40px;
    background: #7bb2d6;
    border-radius: 3.116px;
    color: #FDFDFD;
    display: inline-block;
  }

  .teaching-list-form .el-input {
    width: 330px;
  }

  .el-input-group--prepend .el-input__inner {
    border: none;
  }

  .input-with-select .el-input-group__prepend {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/practice.vue